export const DASHBOARD_PROMPT_BAR_EMPTY_LABEL = 'Describe the dashboard you want to see';

// Shown next to the stored prompt so it reads as an editable request rather than a static caption.
export const DASHBOARD_PROMPT_BAR_EDIT_LABEL = 'Edit';

export const DASHBOARD_PROMPT_BAR_EDIT_TOOLTIP = 'Edit the prompt and rebuild this dashboard';

// The bar's own submit label. Not the starter's "Generate": submitting here revises the dashboard
// that is already on screen rather than building one from nothing.
export const DASHBOARD_PROMPT_BAR_SUBMIT_LABEL = 'Update';

// The expanded editor caps growth lower than the empty state's 18: it sits above an existing
// dashboard, and a box tall enough to bury the whole grid is worse than scrolling inside it.
export const DASHBOARD_PROMPT_BAR_MAX_ROWS = 8;
